import { useStore } from 'react-redux';
import { useApiQuery } from '../../../../infra/api';
import { endpoints } from '../../network';
import { useSession } from '../../../../infra/session';
import { buildApiPayloadAudiencesFromStore } from '../model-mapping/audiences';
import { getCampaignOwnerOrViewerIdAndKind } from '../utils/get-campaign-owner-or-viewer-id-and-kind';
import { useRouteParams } from '../../../../infra/routing';
import { useCampaignDetails } from './use-campaign-details';
export var useClientsByChannel = function () {
    var session = useSession().data;
    var store = useStore();
    var campaignId = useRouteParams().campaignId;
    var campaign = useCampaignDetails(campaignId).campaign;
    var ownerOrViewerIdAndKind = getCampaignOwnerOrViewerIdAndKind(campaign, session);
    var audiences = buildApiPayloadAudiencesFromStore({ session: session, store: store });
    var _a = useApiQuery({
        endpoint: endpoints.clientsByChannelQuery,
        payload: {
            ownerType: ownerOrViewerIdAndKind.kind,
            ownerId: ownerOrViewerIdAndKind.id,
            customerGroups: audiences.customerGroups.length > 0 ? audiences.customerGroups : [{ name: 'all' }],
        },
        options: {
            enabled: !!ownerOrViewerIdAndKind,
        },
    }), data = _a.data, isLoading = _a.isLoading;
    return {
        clients: data,
        isLoading: isLoading,
    };
};
